import { render, staticRenderFns } from "./MusicList.vue?vue&type=template&id=32dba8e8&scoped=true"
import script from "./MusicList.vue?vue&type=script&lang=js"
export * from "./MusicList.vue?vue&type=script&lang=js"
import style0 from "./MusicList.vue?vue&type=style&index=0&id=32dba8e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dba8e8",
  null
  
)

export default component.exports